import {RoomLegacy, RoomResponse} from '../entity/Room';

export const mapRoom = (room: RoomResponse): RoomLegacy => {
    return {
        id: String(room.id),
        jobId: String(room.job_id),
        name: room.name,
        description: room.description,
        carcColour: String(room.carc_colour),
        carcCustomColour: room.carc_custom_colour,
        carcEdgeColour: String(room.carc_edge_colour),
        extColour: String(room.ext_colour),
        extEdgeColour: String(room.ext_edge_colour),
        extCustomColour: room.ext_custom_colour,
        baseHeight: room.base_height,
        baseDepth: room.base_depth,
        upperHeight: room.upper_height,
        upperDepth: room.upper_depth,
        tallHeight: room.tall_height,
        tallDepth: room.tall_depth,
        doorStyle: room.door_style,
        doorSuffixId: room.door_suffix_id,
        hingeStyle: room.hinge_style,
        drawerStyle: room.drawer_style,
        toeKickHeight: room.toe_kick_height,
        drawerGap: room.drawer_gap,
        doorGap: room.door_gap,
        upperTopGap: room.upper_top_gap,
        upperBottomGap: room.upper_bottom_gap,
        baseTopGap: room.base_top_gap,
        baseBottomGap: room.base_bottom_gap,
        leftGap: room.left_gap,
        rightGap: room.right_gap,
        includeAssembly: room.include_assembly,
        excludeHardware: room.exclude_hardware,
        adjustableLegs: room.adjustable_legs,
        extHorGrain: room.ext_hor_grain,
        carcHorGrain: room.carc_hor_grain,
        extDoubleSided: room.ext_double_sided,
        carcDoubleSided: room.carc_double_sided,
        shelfSetBack: room.shelf_set_back,
        doorBorderWidthTop: room.door_border_width_top,
        doorBorderWidthBottom: room.door_border_width_bottom,
        doorBorderWidthLeft: room.door_border_width_left,
        doorBorderWidthRight: room.door_border_width_right,
        doorAdvancedEdgeTop: room.door_advanced_edge_top,
        doorAdvancedEdgeBottom: room.door_advanced_edge_bottom,
        doorAdvancedEdgeLeft: room.door_advanced_edge_left,
        doorAdvancedEdgeRight: room.door_advanced_edge_right,
        doorAdvancedRailHeight: room.door_advanced_rail_height,
        doorAdvancedRailWidth: room.door_advanced_rail_width,
        doorAdvancedBarWidth: room.door_advanced_bar_width,
        defaultSize: room.default_size,
        defaultGap: room.default_gap,
        topPart: Number(room.top_part),
        customerOptions: room.customer_options,
        carcMaterial: {
            id: String(room.carcase_material.id),
            itemCode: room.carcase_material?.item_code,
            name: room.carcase_material?.name,
            finish: room.carcase_material?.finish,
            brand: room.carcase_material?.brand_id,
            substrate: room.carcase_material?.substrate,
            thickness: room.carcase_material?.thickness,
            defaultDoubleSidedCost: room.carcase_material?.double_sided_cost,
            defaultHandlingCost: room.carcase_material?.handling_cost,
            defaultAreaCost: room.carcase_material?.area_cost,
            defaultAreaAssemblyCost: room.carcase_material?.area_assembly_cost,
            defaultMinJobArea: room.carcase_material?.min_job_area,
            defaultLength: room.carcase_material?.length,
            defaultWidth: room.carcase_material?.width,
            length: room.carcase_material?.length,
            width: room.carcase_material?.width,
            prefix: room.carcase_material?.prefix_name,
            prefixId: String(room.carcase_material?.prefix_id),
            doorFilter: room.carcase_material?.door_filter,
            image: room.carcase_material?.image,
            horGrain: room.carcase_material?.is_grained,
            doubleSided: room.carcase_material?.is_double_sided,
            manufacturers: String(room.carcase_material?.manufacturer_id),
            type: room.carcase_material?.type_id,
            typeName: room.carcase_material?.type?.name,
            hiddenAsDefault: String(
                room.carcase_material?.is_hidden_by_default
            ),
            gfpName: room.carcase_material?.gfp_name,
            gfpBrandId: String(room.carcase_material?.gfp_brand_id),
            gfpTypeId: String(room.carcase_material?.gfp_type_id),
            gfpFinishId: String(room.carcase_material?.gfp_finish_id),
            hidden: room.carcase_material?.changed_is_hidden ?? true,
            manufacturerId: room.carcase_material?.manufacturer_id,
            minimumUsageRollover: String(
                room.carcase_material?.minimum_usage_rollover
            ),
            expectedYieldFactor: String(
                room.carcase_material?.expected_yield_factor
            ),
            carcHorGrain: room.carc_hor_grain,
            extHorGrain: room.ext_hor_grain,
            brandName: room.carcase_material?.brand?.name,
            changedItemCode: room.carcase_material?.changed_item_code,
            changedHorGrainSurcharge:
                room.carcase_material?.changed_horizontal_grain_surcharge,
            changedDoubleSidedCost:
                room.carcase_material?.changed_double_sided_cost,
            changedHandlingCost: room.carcase_material?.changed_handling_cost,
            changedAreaCost: room.carcase_material?.changed_area_cost,
            changedAreaAssemblyCost:
                room.carcase_material?.changed_area_assembly_cost,
            changedMinJobArea: room.carcase_material?.changed_min_job_area,
            changedLength: room.carcase_material?.changed_length,
            changedWidth: room.carcase_material?.changed_width,
        },
        carcEdge: {
            id: room.carcase_edge_material?.id,
            itemCode: room.carcase_edge_material?.item_code,
            name: room.carcase_edge_material?.name,
            brand: room.carcase_edge_material?.brand_id,
            finish: room.carcase_edge_material?.finish,
            thickness: room.carcase_edge_material?.thickness,
            defaultLengthCost: room.carcase_edge_material?.length_cost,
            defaultHandlingCost: room.carcase_edge_material?.handling_cost,
            defaultAreaHandlingCost:
                room.carcase_edge_material?.area_handling_cost,
            defaultApplicationCost:
                room.carcase_edge_material?.application_cost,
            doorFilter: room.carcase_edge_material?.door_filter,
            image: room.carcase_edge_material?.image,
            manufacturers: -1,
            manufacturerId: room.carcase_edge_material?.manufacturer_id,
            hidden: room.carcase_edge_material?.changed_is_hidden ?? true,
            type: room.carcase_edge_material?.material_type_id,
            typeName: room.carcase_edge_material?.material_type?.name,
            brandName: room.carcase_edge_material?.brand?.name,
            changedItemCode: room.carcase_edge_material?.changed_item_code,
            changedHandlingCost:
                room.carcase_edge_material?.changed_handling_cost,
            changedLengthCost: room.carcase_edge_material?.changed_length_cost,
            changedAreaHandlingCost:
                room.carcase_edge_material?.changed_area_handling_cost,
            changedApplicationCost:
                room.carcase_edge_material?.changed_application_cost,
        },
        extMaterial: {
            id: String(room.exterior_material.id),
            itemCode: room.exterior_material?.item_code,
            name: room.exterior_material?.name,
            finish: room.exterior_material?.finish,
            brand: room.exterior_material?.brand_id,
            substrate: room.exterior_material?.substrate,
            thickness: room.exterior_material?.thickness,
            defaultDoubleSidedCost: room.exterior_material?.double_sided_cost,
            defaultHandlingCost: room.exterior_material?.handling_cost,
            defaultAreaCost: room.exterior_material?.area_cost,
            defaultAreaAssemblyCost: room.exterior_material?.area_assembly_cost,
            defaultMinJobArea: room.exterior_material?.min_job_area,
            defaultLength: room.exterior_material?.length,
            defaultWidth: room.exterior_material?.width,
            length: room.exterior_material?.length,
            width: room.exterior_material?.width,
            prefix: room.exterior_material?.prefix_name,
            prefixId: String(room.exterior_material?.prefix_id),
            doorFilter: room.exterior_material?.door_filter,
            image: room.exterior_material?.image,
            horGrain: room.exterior_material?.is_grained,
            doubleSided: room.exterior_material?.is_double_sided,
            manufacturers: String(room.exterior_material?.manufacturer_id),
            type: room.exterior_material?.type_id,
            typeName: room.exterior_material?.type?.name,
            hiddenAsDefault: String(
                room.exterior_material?.is_hidden_by_default
            ),
            gfpName: room.exterior_material?.gfp_name,
            gfpBrandId: String(room.exterior_material?.gfp_brand_id),
            gfpTypeId: String(room.exterior_material?.gfp_type_id),
            gfpFinishId: String(room.exterior_material?.gfp_finish_id),
            hidden: room.exterior_material?.changed_is_hidden ?? true,
            manufacturerId: room.exterior_material?.manufacturer_id,
            minimumUsageRollover: String(
                room.exterior_material?.minimum_usage_rollover
            ),
            expectedYieldFactor: String(
                room.exterior_material?.expected_yield_factor
            ),
            carcHorGrain: room.carc_hor_grain,
            extHorGrain: room.ext_hor_grain,
            brandName: room.exterior_material?.brand?.name,
            changedItemCode: room.exterior_material?.changed_item_code,
            changedHorGrainSurcharge:
                room.exterior_material?.changed_horizontal_grain_surcharge,
            changedDoubleSidedCost:
                room.exterior_material?.changed_double_sided_cost,
            changedHandlingCost: room.exterior_material?.changed_handling_cost,
            changedAreaCost: room.exterior_material?.changed_area_cost,
            changedAreaAssemblyCost:
                room.exterior_material?.changed_area_assembly_cost,
            changedMinJobArea: room.exterior_material?.changed_min_job_area,
            changedLength: room.exterior_material?.changed_length,
            changedWidth: room.exterior_material?.changed_width,
        },
        extEdge: {
            id: room.exterior_edge_material?.id,
            itemCode: room.exterior_edge_material?.item_code,
            name: room.exterior_edge_material?.name,
            brand: room.exterior_edge_material?.brand_id,
            finish: room.exterior_edge_material?.finish,
            thickness: room.exterior_edge_material?.thickness,
            defaultLengthCost: room.exterior_edge_material?.length_cost,
            defaultHandlingCost: room.exterior_edge_material?.handling_cost,
            defaultAreaHandlingCost:
                room.exterior_edge_material?.area_handling_cost,
            defaultApplicationCost:
                room.exterior_edge_material?.application_cost,
            doorFilter: room.exterior_edge_material?.door_filter,
            image: room.exterior_edge_material?.image,
            manufacturers: -1,
            manufacturerId: room.exterior_edge_material?.manufacturer_id,
            hidden: room.exterior_edge_material?.changed_is_hidden ?? true,
            type: room.exterior_edge_material?.material_type_id,
            typeName: room.exterior_edge_material?.material_type?.name,
            brandName: room.exterior_edge_material?.brand?.name,
            changedHandlingCost:
                room.exterior_edge_material?.changed_handling_cost,
            changedLengthCost: room.exterior_edge_material?.changed_length_cost,
            changedAreaHandlingCost:
                room.exterior_edge_material?.changed_area_handling_cost,
            changedApplicationCost:
                room.exterior_edge_material?.changed_application_cost,
        },
        door: {
            minimumDrawerHeight: room.door?.minimum_drawer_height,
            defaultEdgeFinishTop: room.door?.default_edge_finish_top,
            defaultEdgeFinishBottom: room.door?.default_edge_finish_bottom,
            defaultEdgeFinishLeft: room.door?.default_edge_finish_left,
            defaultEdgeFinishRight: room.door?.default_edge_finish_right,
            defaultEdgeFinishJoin: room.door?.default_edge_finish_join,
            setAsDefaultEdgeFinish: Number(room.door?.is_default_edge_finish),
            isDefaultEdgeFinish: room.door?.is_default_edge_finish,
            lockDefaultEdgeFinish: Number(room.door?.is_locked_edge_finish),
            itemCode: room.door?.item_code,
            id: room.door?.id,
            name: room.door?.name,
            outsourced: room.door?.is_outsourced,
            filterName: room.door?.filter_name,
            defaultHandlingCost: room.door?.handling_cost,
            defaultAreaHandlingCost: room.door?.area_handling_cost,
            defaultMachiningCost: room.door?.machining_cost,
            defaultAreaMachiningCost: room.door?.area_machining_cost,
            defaultUnitCost: room.door?.unit_cost,
            defaultAssemblyCost: room.door?.assembly_cost,
            defaultAreaAssemblyCost: room.door?.area_assembly_cost,
            suffix: room.door?.suffix_name,
            suffixId: room.door?.suffix_id,
            advanced: Number(room.door?.is_advanced),
            image: room.door?.image_id,
            image_name: room.door?.image_name,
            manufacturers: room.door?.manufacturer_id,
            defaultBrand: room.door?.default_brand_id,
            defaultFinish: room.door?.default_finish,
            defaultColour: room.door?.default_material_id,
            setAsDefaultEdgeType: room.door?.is_default_edge_type,
            lockDefaultEdgeType: room.door?.is_default_edge_type_locked,
            minimumHeight: room.door?.minimum_height,
            minimumHeightDrawer: room.door?.minimum_drawer_height,
            maximumHeight: room.door?.maximum_height,
            minimumWidth: room.door?.minimum_width,
            maximumWidth: room.door?.maximum_width,
            minimumBorderWidthTop: room.door?.minimum_border_width_top,
            minimumBorderWidthBottom: room.door?.minimum_border_width_bottom,
            minimumBorderWidthLeft: room.door?.minimum_border_width_left,
            minimumBorderWidthRight: room.door?.minimum_border_width_right,
            minimumDistanceTopBottom: room.door?.minimum_distance_top_bottom,
            minimumDistanceLeftRight: room.door?.minimum_distance_left_right,
            defaultBorderWidthTop: room.door?.default_border_width_top,
            defaultBorderWidthBottom: room.door?.default_border_width_bottom,
            defaultBorderWidthLeft: room.door?.default_border_width_left,
            defaultBorderWidthRight: room.door?.default_border_width_right,
            minimumRailsHorizontalHeight:
                room.door?.minimum_rails_horizontal_height,
            maximumRailsHorizontalHeight:
                room.door?.maximum_rails_horizontal_height,
            minimumRailsVerticalWidth: room.door?.minimum_rails_vertical_width,
            maximumRailsVerticalWidth: room.door?.maximum_rails_vertical_width,
            defaultRailsHorizontalHeight:
                room.door?.default_rails_horizontal_height,
            defaultRailsVerticalWidth: room.door?.default_rails_vertical_width,
            hidden: room.door?.changed_is_hidden ?? true,
            manufacturerId: room.door?.manufacturer_id,
            changedHandlingCost: room.door?.changed_handling_cost,
            changedAreaHandlingCost: room.door?.changed_area_handling_cost,
            changedMachiningCost: room.door?.changed_machining_cost,
            changedAreaMachiningCost: room.door?.changed_area_machining_cost,
            changedUnitCost: room.door?.changed_unit_cost,
            changedAssemblyCost: room.door?.changed_assembly_cost,
            changedAreaAssemblyCost: room.door?.changed_area_assembly_cost,
            changedDefaultEdgeFinishTop:
                room.door?.changed_default_edge_finish_top,
            changedDefaultEdgeFinishBottom:
                room.door?.changed_default_edge_finish_bottom,
            changedDefaultEdgeFinishLeft:
                room.door?.changed_default_edge_finish_left,
            changedDefaultEdgeFinishRight:
                room.door?.changed_default_edge_finish_right,
            changedDefaultEdgeFinishJoin:
                room.door?.changed_default_edge_finish_join,
            changedSetAsDefaultEdgeFinish: Number(
                room.door?.changed_is_default_edge_finish
            ),
            changedLockDefaultEdgeFinish: Number(
                room.door?.changed_is_locked_edge_finish
            ),
            changedMarkupCollectiveFace:
                room.door?.changed_markup_collective_face,
            changedMarkupIndividualFace:
                room.door?.changed_markup_individual_face,
            changedMarkupReducedRails: room.door?.changed_markup_reduced_rails,
        },
        UpperBottomGap: room.upper_top_gap,
    };
};
